<template>
  <div
    class="calciatore-battuto"
    v-if="Calciatore"
    :class="sizeClass"
    :style="{
      backgroundImage: `url(${
        Calciatore.ID_Club
          ? Config.PUBLIC_DIR +
            '/clubs/maglie/400x400/ID_Anno_' +
            Config.ID_ANNO_MAGLIE +
            '/img_scheda_club_' +
            Calciatore.ID_Club +
            '.png'
          : ''
      })`,
    }"
  >
    <div v-if="sizeClass != 'small'">
      <div class="nomeCalciatore">
        <span
          v-if="classic"
          :class="['Ruolo', 'Ruolo_' + Calciatore.ID_Ruolo]"
          >{{ ruolo(Calciatore.ID_Ruolo) }}</span
        >
        {{ Calciatore.calciatore }}
        <span v-if="mantra">
          <span
            v-for="mantra_id in Calciatore.mantra_ids"
            :key="mantra_id"
            :class="['ml-1', 'ruolo-mantra', 'ruolo-mantra' + mantra_id]"
            >{{ ruoloMantra(mantra_id) }}</span
          >
        </span>
      </div>
      <div class="photo">
        <div class="imgCalciatore without-ms">
          <div class="imgContainer imgContainer-ruolo_">
            <div
              v-if="Config.AVATAR_OR_FLAG == 'avatar'"
              class="img"
              :key="Calciatore.nid"
              :style="{
                backgroundImage: `url(${
                  Calciatore.imgCalciatore
                    ? Calciatore.imgCalciatore
                    : Config.PUBLIC_DIR +
                      '/schede_calciatori/avatar/default/avatar_club_' +
                      Calciatore.ID_Club +
                      '.png'
                })`,
              }"
            ></div>

            <div
              v-if="Config.AVATAR_OR_FLAG == 'flag'"
              class="img flag"
              :key="Calciatore.nid"
              :style="{
                backgroundImage: `url(${
                  Config.PUBLIC_DIR +
                  '/clubs/flags/flag_' +
                  Calciatore.ID_Club +
                  '.png'
                })`,
              }"
            ></div>
          </div>
        </div>
      </div>

      <span class="nomeClub ellipsis">{{ Calciatore.nomeClub }}</span>
      <span
        class="Quotazione"
        v-if="
          asta_settings &&
          asta_settings.base_asta == Constants.BASE_ASTA.QUOTAZIONE
        "
        >Q {{ Calciatore.quotazione }}</span
      >
      <span class="mainStatusPlaceholder"
        ><main-status :ms="Calciatore.ms"></main-status
      ></span>
    </div>
    <div v-else class="d-flex">
      <div class="photo">
        <div class="imgCalciatore without-ms">
          <div class="imgContainer imgContainer-ruolo_">
            <div
              v-if="Config.AVATAR_OR_FLAG == 'avatar'"
              class="img"
              :key="Calciatore.nid"
              :style="{
                backgroundImage: `url(${
                  Calciatore.imgCalciatore
                    ? Calciatore.imgCalciatore
                    : Config.PUBLIC_DIR +
                      '/schede_calciatori/avatar/default/avatar_club_' +
                      Calciatore.ID_Club +
                      '.png'
                })`,
              }"
            ></div>

            <div
              v-if="Config.AVATAR_OR_FLAG == 'flag'"
              class="img flag"
              :key="Calciatore.nid"
              :style="{
                backgroundImage: `url(${
                  Config.PUBLIC_DIR +
                  '/clubs/flags/flag_' +
                  Calciatore.ID_Club +
                  '.png'
                })`,
              }"
            ></div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column align-start justify-space-around">
        <div class="nomeCalciatore">
          <span :class="['Ruolo', 'Ruolo_' + Calciatore.ID_Ruolo]">{{
            ruolo(Calciatore.ID_Ruolo)
          }}</span>
          {{ Calciatore.calciatore }}
        </div>
        <span class="nomeClub ellipsis">{{ Calciatore.nomeClub }}</span>
      </div>
      <span
        class="Quotazione"
        v-if="
          asta_settings &&
          asta_settings.base_asta == Constants.BASE_ASTA.QUOTAZIONE
        "
        >Q {{ Calciatore.quotazione }}</span
      >
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";

import db from "../../js/db";
import mixins from "../../js/mixins";
import Config from "../../../config-app/config";
import Constants from "../../js/constants";
import MainStatus from "./MainStatus";

export default {
  name: "calciatore-battuto",
  mixins: [mixins],
  components: {
    MainStatus,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    clicked: {
      type: Function,
      default: function () {},
    },
    xLarge: {
      type: Boolean,
    },
  },
  mounted() {},
  computed: {
    sizeClass() {
      if (!this.xLarge) {
        if (
          this.squadreSize &&
          this.squadreSize == Constants.SQUADRE_SIZE.SMALL
        ) {
          return "small";
        }
        if (
          this.squadreSize &&
          this.squadreSize == Constants.SQUADRE_SIZE.MEDIUM
        ) {
          return "medium";
        }
        if (
          this.squadreSize &&
          this.squadreSize == Constants.SQUADRE_SIZE.LARGE
        ) {
          return "large";
        }
      }

      return "x-large";
    },
    Calciatore() {
      return this.calciatori[this.id];
    },
    ...Vuex.mapGetters(["calciatori", "squadreSize"]),
  },
};
</script>
<style lang="scss" scoped>
.calciatore-battuto {
  color: #ffffff;
  background-color: #607d8b;
  background-image: linear-gradient(#607d8b, #455a64);
  border-radius: 1em;
  box-shadow: 0px 1px 14px 10px rgb(0 0 0 / 12%);
  // x-large
  width: 270px;
  padding: 10px;
  text-align: center;
  margin: 15px auto 10px;
  background-size: cover;
  background-position: 120px -25px;
  position: relative;
  &.large {
    width: 220px;
    padding: 10px 0px 0px 10px;
    background-position: 108px -25px;
    .photo {
      margin-left: 25px;
      margin-top: 7px;
      .imgCalciatore {
        width: 70px;
        height: 70px;
        .imgContainer {
          .img {
            width: 65px;
          }
        }
      }
    }
  }
  &.medium {
    width: 180px;
    padding: 5px 0px 0px 10px;
    background-position: 90px -25px;
    .photo {
      margin-left: 15px;
      margin-top: 5px;
      .imgCalciatore {
        width: 50px;
        height: 50px;
        .imgContainer {
          .img {
            width: 45px;
          }
        }
      }
    }
  }
  &.small {
    width: 200px;
    background-position: 135px -12px;
    background-size: 115px;
    .photo {
      margin-left: 0;
      margin-top: 0;
      margin-right: 3px;
      .imgCalciatore {
        width: 50px;
        height: 50px;
        .imgContainer {
          .img {
            width: 45px;
          }
        }
      }
    }
  }
  .photo {
    margin-left: 1em;
    margin-top: 1em;
    .imgCalciatore {
      width: 90px;
      height: 90px;
      margin: 0;
      .imgContainer {
        box-shadow: 0px 1px 10px 3px rgb(0 0 0 / 12%);
        .img {
          width: 80px;
          &.flag {
            width: 80%;
          }
        }
      }
    }
  }
  .Ruolo {
    margin-right: 10px;
    box-shadow: 0px 1px 10px 3px rgb(0 0 0 / 12%);
  }
  span.Quotazione {
    position: absolute;
    bottom: 10px;
    left: 15px;
    // box-shadow: 0px 1px 10px 3px rgb(0 0 0 / 12%);
  }
  span.mainStatusPlaceholder {
    position: absolute;
    bottom: 5px;
    right: 10px;
    background: rgba(0, 0, 0, .3);
    border-radius: 100px;
    padding: 5px;
    display: flex;
    align-items: center;
  }
  .nomeCalciatore {
    font-weight: 700;
    font-size: 1.2em;
    line-height: 1em;
    display: flex;
    align-items: center;
  }
  .nomeClub {
    color: #263238;
  }
}
</style>
